<style>
</style>

<template>
	<v-dialog v-model="visible" max-width="350" persistent>
		<v-card>
			<v-card-title class="px-10">
				<task_icon :status_type="4" />
				<span style="color: red;margin-left: 5px">Status Change</span>
			</v-card-title>
			<v-card-text class="px-10">
				<v-alert type="error" v-if="errormsg != ''">{{
					errormsg
				}}</v-alert>

				<div>
					Are you sure you want to notify the project team?
				</div>
			</v-card-text>
			<v-card-actions class="d-flex align-end flex-column">
				<div>
					<jbsmall_button @click="save()" style="float:right" color="blue">Yes</jbsmall_button>
					<jbsmall_button @click="close()" style="float:right" color="red">Cancel</jbsmall_button>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import task_icon from "@/components/tasks/task_icon"
import jbsmall_button from "@/components/controls/jbsmall_button"

export default {
	components: {
		task_icon, jbsmall_button
	},
	data() {
		return {
			errormsg: '',
			task_id: 0,
			status_id: 0,
			visible: false
		}
	},
	methods: {
		open: function(task_id, status_id) {
			this.errormsg = '';
			this.task_id = task_id;
			this.status_id = status_id;
			this.visible = true;
		},
		save: function() {
			let self = this;

			axios
				.put("/api/tasks/" + this.task_id, {
					status: {
						id: this.status_id
					}
				}, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// close our dialog
						self.visible = false;

						// let the world know
						self.$emit('saved');
					} else {
						self.errormsg = json.reason;						
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
		},
		close: function() {
			this.visible = false;
		}

	}
}
</script>
